import React, { useContext, useEffect, useMemo, useState } from "react";
import DetailLayout from "../../components/DetailLayout";
import ExerciseDetailHeader from "./components/ExerciseDetailHeader";
import ExerciseStuList from "./components/ExerciseStuList";
import style from "./index.module.scss";
import ExerciseListItem from "./components/ExerciseListItem";
import useRequest from "../../../../utils/useRequest";
import {
    getQuestionInfo,
    getStuJoinInQuestionnaireList,
    StuInfo
} from "service/question";
import { useParams } from "react-router-dom";
import LoadingWrapper from "../../../../components/LoadingWrapper";
import { CourseContext } from "../../Store";
import { useInterval } from "react-use";

export default function ExerciseDetail() {
    const { questionnaireId } = useParams();
    const [data, { loading }, getExercise] = useRequest(
        () => getQuestionInfo({ questionnaireId }),
        {},
        [questionnaireId]
    );
    const { course } = useContext(CourseContext);
    const [stuListData, { loading: stuListLoading }, doRefresh] = useRequest(
        () => getStuJoinInQuestionnaireList(questionnaireId, course.courseId),
        { autoStart: true },
        [questionnaireId, course.courseId]
    );
    const [searchKey, setSearchKey] = useState("");
    const [searchType, setSearchType] = useState("all");
    const [dataList, setDataList] = useState<StuInfo[]>([]);
    const [joinInCount, setJoinInCount] = useState(0);
    const [noJoinInCount, setNoJoinInCount] = useState(0);

    const showDataList = useMemo(() => {
        const pattern = new RegExp(searchKey, "i");
        let filterData = dataList.filter(
            item => pattern.test(item.name) || item.studentId === searchKey
        );
        if (searchType !== "all")
            filterData = filterData.filter(
                item =>
                    parseInt(item.stuStatus) ===
                    (searchType === "committed" ? 1 : 0)
            );
        return filterData;
    }, [dataList, searchKey, searchType]);

    useInterval(getActualTimeData, 5000);

    useEffect(() => {
        if (stuListData) {
            setPropertiesData(stuListData);
        }
    }, [stuListData]);

    // 获取实时数据
    function getActualTimeData() {
        getStuJoinInQuestionnaireList(questionnaireId, course.courseId).then(
            data => {
                setPropertiesData(data);
            }
        );
    }

    // 更新数据
    function setPropertiesData(data: {
        list: StuInfo[];
        joinInCount: number;
        noJoinInCount: number;
    }) {
        setDataList(data.list);
        setJoinInCount(data.joinInCount);
        setNoJoinInCount(data.noJoinInCount);
    }

    return (
        <DetailLayout breadcrumb="开始问卷">
            <LoadingWrapper loading={loading || stuListLoading} isEmpty={false}>
                {() => (
                    <div>
                        {data && <ExerciseDetailHeader exerciseInfo={data} />}
                        <div className={style.main}>
                            <div className={style.left}>
                                {data?.questionModels.map((item, index) => (
                                    <ExerciseListItem
                                        key={item.id}
                                        index={index + 1}
                                        data={item}
                                    />
                                ))}
                            </div>

                            <ExerciseStuList
                                questionnaireId={questionnaireId}
                                data={showDataList}
                                joinInCount={joinInCount}
                                noJoinInCount={noJoinInCount}
                                onChange={setSearchKey}
                                onChangeType={setSearchType}
                                pageData={data}
                            />
                        </div>
                    </div>
                )}
            </LoadingWrapper>
        </DetailLayout>
    );
}
